import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import AddEntityButton from "../../../components/AddEntityButton";
import CustomerFormModal from "./CustomerFormModal";

const AddCustomer = ({
  reloadCallback,
  onSuccess,
  iconOnly = true,
  buttonProps = {},
}) => {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);

  const handleSuccess = (response, values) => {
    reloadCallback?.(response, values);
    onSuccess?.(response, values);
  };

  return (
    <>
      <AddEntityButton
        iconOnly={iconOnly}
        buttonProps={{
          ...buttonProps,
          key: "open-customer-modal",
          onClick: () => setModalOpen(true),
        }}
      >
        + {t("customer_add")}
      </AddEntityButton>

      <CustomerFormModal
        open={modalOpen}
        mode="add"
        onClose={() => setModalOpen(false)}
        onSuccess={handleSuccess}
      />
    </>
  );
};

export default AddCustomer;
